import { useEffect } from 'react'

export default function useClickOutside(ref, callback, off, mouseDownTarget) {
  useEffect(() => {
    const listener = (event) => {
      if (
        ref.current &&
        !(event.path || event.composedPath()).includes(ref.current) &&
        event.target === mouseDownTarget?.current
      )
        callback()
    }

    if (!off) {
      document.addEventListener('mouseup', listener)
    }

    return () => {
      document.removeEventListener('mouseup', listener)
    }
  }, [ref, callback, off, mouseDownTarget])
}
